import React, {FC} from 'react';
import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {TeamModel} from '../../../../models/api/teamModel';
import {VisualWorkspaceTeamData} from '../../../../models/api/visualWorkspaceModel';
import {AppState} from '../../../../store/appState';
import {getTeams} from '../../../../store/data/teams/teamsSelectors';
import {InboxesPanelId} from '../../../../store/panels/panelStateBase';
import {TeamWorkspaceContainer} from './teamWorkspaceContainer';

/*
 * Props.
 */

export interface MaybeTeamWorkspaceContainerProps {
  /** Teams data passed from VisualWorkspaceModel */
  visualWorkspaceTeam: VisualWorkspaceTeamData;
  panelId: InboxesPanelId;
  /** Whether this is the first team. */
  isFirstTeam: boolean;
}

interface MaybeTeamWorkspaceContainerComponentProps {
  team: TeamModel | undefined;
  /** Teams data passed from VisualWorkspaceModel */
  visualWorkspaceTeam: VisualWorkspaceTeamData;
  panelId: InboxesPanelId;
  /** Whether this is the first team. */
  isFirstTeam: boolean;
}

/*
 * Selectors.
 */

function getTeamId(_state: AppState, props: MaybeTeamWorkspaceContainerProps) {
  return props.visualWorkspaceTeam.teamId;
}

function makeGetTeam() {
  return createSelector([getTeams, getTeamId], (teams, id) => teams[id]);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MaybeTeamWorkspaceContainerProps>()(() => ({
  team: makeGetTeam(),
}));

const MaybeTeamWorkspaceContainerComponent: FC<MaybeTeamWorkspaceContainerComponentProps> = (props) => {
  const {team, visualWorkspaceTeam, panelId, isFirstTeam} = props;
  return team ? (
    <TeamWorkspaceContainer
      team={team}
      visualWorkspaceTeam={visualWorkspaceTeam}
      panelId={panelId}
      isFirstTeam={isFirstTeam}
    />
  ) : null;
};

export const MaybeTeamWorkspaceContainer = connect(mapStateToProps)(MaybeTeamWorkspaceContainerComponent);
